/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Dashboard Customise (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_DASHBOARD_CUSTOMISE_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0C136.601 0 176 39.3989 176 88V144C176 161.673 161.673 176 144 176H88C39.3989 176 0 136.601 0 88Z"
      fill="#F5F5F5"
    />
    <path
      d="M48 43H78C80.75 43 83 45.25 83 48V78C83 80.75 80.75 83 78 83H48C45.25 83 43 80.75 43 78V48C43 45.25 45.25 43 48 43ZM98 43H128C130.75 43 133 45.25 133 48V78C133 80.75 130.75 83 128 83H98C95.25 83 93 80.75 93 78V48C93 45.25 95.25 43 98 43ZM48 93H78C80.75 93 83 95.25 83 98V128C83 130.75 80.75 133 78 133H48C45.25 133 43 130.75 43 128V98C43 95.25 45.25 93 48 93ZM113 93C110.25 93 108 95.25 108 98V108H98C95.25 108 93 110.25 93 113C93 115.75 95.25 118 98 118H108V128C108 130.75 110.25 133 113 133C115.75 133 118 130.75 118 128V118H128C130.75 118 133 115.75 133 113C133 110.25 130.75 108 128 108H118V98C118 95.25 115.75 93 113 93Z"
      fill="#707070"
    />
    <circle cx="132.5" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132 107.833C118.636 107.833 107.833 118.636 107.833 132C107.833 145.364 118.636 156.167 132 156.167C145.364 156.167 156.167 145.364 156.167 132C156.167 118.636 145.364 107.833 132 107.833Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="138" />
  </svg>
);
